import { DimensionsState } from '../../../../@types';

const initialState: DimensionsState = {
  headerHeight: 0,
};
export default initialState;
